import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { HttpClient } from '@wix/yoshi-flow-bm';
import { getIFrameInstance } from '@app/utils';
import adsenseAdunits from './slices/adsense-adunits-slice';
import adsenseUser from './slices/adsense-user-slice';

const rootReducer = combineReducers({
  adsenseUser,
  adsenseAdunits,
});

const httpClient = new HttpClient({
  headers: { authorization: getIFrameInstance() },
});

type CreateStoreParams = {
  wixSdk: any;
  t: any;
  settings: any;
};

export const createSettingsStore = ({
  wixSdk,
  t,
  settings,
}: CreateStoreParams) => {
  const extraArgument = { wixSdk, t, httpClient, settings };

  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
        thunk: { extraArgument },
      }),
  });
};

export type SettingsStore = ReturnType<typeof createSettingsStore>;
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = ReturnType<typeof createSettingsStore>['dispatch'];
